export default "__VITE_ASSET__CBAD21Ri__"